import React, { useEffect } from "react";
import styled from "styled-components";
import { Link, Outlet, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Nav from "../organisms/Nav";
import { setCategory } from "../../store/categorySlice";

// Wrap: 전체 페이지 레이아웃 (좌측 Nav + 우측 본문)
const Wrap = styled.div`
    display: flex;
    width: 100%;
    height: 100vh;
`;

// PageWrapContainer: Nav 옆에 위치하며 내부 콘텐츠가 많을 때 스크롤 가능하도록 함
const PageWrapContainer = styled.div`
    flex: 1;
    overflow-y: auto;
`;

// PageWrap: 본문 영역 내부의 여백과 레이아웃을 설정
const PageWrap = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 30px;
    gap: 52px;
`;

// InnerWrap: Outlet 콘텐츠 배치를 위한 컨테이너
const InnerWrap = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 30px;
`;

// CustomCategoryWrap: Category 링크들을 감싸는 스타일 컴포넌트를 모듈 최상단에 정의
const CustomCategoryWrap = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 5px;

    a {
        display: flex;
        flex-direction: row;
        gap: 5px;
        color: var(--gray3-color);
        font-size: 14px;

        &:not(:last-child)::after {
            width: 18px;
            height: 18px;
            content: url("/image/icn_chevron_right_darkgray.svg");
            display: inline-flex;
        }
    }
`;

// CategoryWrap 컴포넌트: Redux의 category state를 가져와 링크 목록을 렌더링
const CategoryWrap = () => {
    const category = useSelector((state) => state.category).value;
    return (
        <CustomCategoryWrap>
            {category.map((el) => (
                <Link key={el.link} to={el.link}>
                    {el.name}
                </Link>
            ))}
        </CustomCategoryWrap>
    );
};

const LoadingWrap = () => {
    return (
        <CustomLoadingBg>
            <span className="loader"></span>
        </CustomLoadingBg>
    );
};

const CustomLoadingBg = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    background-color: transparent;

    .loader {
        width: 12px;
        height: 12px;
        border-radius: 50%;
        display: block;
        margin: 15px auto;
        position: relative;
        color: var(--deep-dark-color);
        box-sizing: border-box;
        animation: animloader 1s linear infinite alternate;
    }

    @keyframes animloader {
        0% {
            box-shadow: -38px -12px, -14px 0, 14px 0, 38px 0;
        }
        33% {
            box-shadow: -38px 0px, -14px -12px, 14px 0, 38px 0;
        }
        66% {
            box-shadow: -38px 0px, -14px 0, 14px -12px, 38px 0;
        }
        100% {
            box-shadow: -38px 0, -14px 0, 14px 0, 38px -12px;
        }
    }
`;

// PageTemplate 컴포넌트: 현재 경로를 기반으로 category를 설정하고, Nav와 Outlet을 포함하는 페이지 레이아웃을 구성
const PageTemplate = (props) => {
    const dispatch = useDispatch();
    const pathname = useLocation().pathname;

    const isLoading = useSelector((state) => state.loader).value;

    useEffect(() => {
        console.log("@PageTemplate - Loading", isLoading);
    }, [isLoading]);

    useEffect(() => {
        dispatch(setCategory(pathname));
    }, [dispatch, pathname]);

    return (
        <Wrap>
            {isLoading && (
                <>
                    <LoadingWrap />
                </>
            )}

            <Nav />
            <PageWrapContainer>
                <PageWrap {...props}>
                    <CategoryWrap />
                    <InnerWrap>
                        <Outlet />
                    </InnerWrap>
                </PageWrap>
            </PageWrapContainer>
        </Wrap>
    );
};

export default PageTemplate;
